export default __webpack_public_path__ + "anton@2x.d413fdae.jpg";